import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { d as s1 } from "./keys-CQjWNUL0.mjs";
import { i as c1 } from "./correct-is-regexp-logic-DUuS52mu.mjs";
import { f as x } from "./_arrayPush-DUvcoEi5.mjs";
import { l as d1 } from "./lodash-5ofSKtz3.mjs";
import L from "react";
import { F as m1 } from "./fabric-icon-CNOLIwc_.mjs";
import { d as g1 } from "./index-DspsydPg.mjs";
import { g } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { r as p1, b as f1 } from "./index-isgVnOkQ.mjs";
import { m as E, u as M1 } from "./tss-DN0acMKN.mjs";
import { M as h1, d as u1 } from "./constants-CnFYFetN.mjs";
import { f as Z1 } from "./index-LyFokDcn.mjs";
import { B as x1 } from "./base-icon-v2-DZwX3wnO.mjs";
const b = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M11,14 C11.5522847,14 12,14.4477153 12,15 C12,15.5522847 11.5522847,16 11,16 L5,16 C4.44771525,16 4,15.5522847 4,15 C4,14.4477153 4.44771525,14 5,14 L11,14 Z M4.5723375,10.0561048 L4.64017874,10.1099653 L5.5,10.9698134 L6.35982126,10.1099653 C6.5064371,9.9633449 6.74342229,9.9633449 6.89003812,10.1099653 C7.01570884,10.23564 7.0336618,10.4277105 6.943897,10.5723554 L6.89003812,10.6401987 L6.03021686,11.5000469 L6.89003812,12.359895 C7.03665396,12.5065154 7.03665396,12.743508 6.89003812,12.8901284 C6.81691769,12.9632511 6.72092369,13 6.62492969,13 C6.55293419,13 6.48093869,12.9793288 6.41859298,12.9381445 L6.35982126,12.8901284 L5.5,12.0302803 L4.64017874,12.8901284 C4.56705831,12.9632511 4.47106431,13 4.37507031,13 C4.27907631,13 4.18308231,12.9632511 4.10996188,12.8901284 C3.98429116,12.7644538 3.9663382,12.5723833 4.056103,12.4277384 L4.10996188,12.359895 L4.96978314,11.5000469 L4.10996188,10.6401987 C3.96334604,10.4935783 3.96334604,10.2565857 4.10996188,10.1099653 C4.23563259,9.98429067 4.42769712,9.96633715 4.5723375,10.0561048 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
b.displayName = "FileTypeEsig16x20";
const y = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M15,18 C15.5522847,18 16,18.4477153 16,19 C16,19.5522847 15.5522847,20 15,20 L5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.4477153 4.44771525,18 5,18 L15,18 Z M4.78427694,12.0886963 L4.85357165,12.1466204 L6,13.2930846 L7.14642835,12.1466204 C7.34191613,11.9511265 7.65789638,11.9511265 7.85338416,12.1466204 C8.02715108,12.3203928 8.04645852,12.589372 7.91130647,12.7843015 L7.85338416,12.8535983 L6.70695582,14.0000625 L7.85338416,15.1465267 C8.04887195,15.3420206 8.04887195,15.6580107 7.85338416,15.8535046 C7.75589026,15.9510015 7.62789826,16 7.49990626,16 C7.40391226,16 7.30791826,15.9724384 7.22479064,15.917526 L7.14642835,15.8535046 L6,14.7070404 L4.85357165,15.8535046 C4.75607775,15.9510015 4.62808574,16 4.50009374,16 C4.37210174,16 4.24410974,15.9510015 4.14661584,15.8535046 C3.97284892,15.6797322 3.95354148,15.410753 4.08869353,15.2158235 L4.14661584,15.1465267 L5.29304418,14.0000625 L4.14661584,12.8535983 C3.95112805,12.6581044 3.95112805,12.3421143 4.14661584,12.1466204 C4.32038275,11.9728481 4.5893536,11.95354 4.78427694,12.0886963 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
y.displayName = "FileTypeEsig20x24";
const R = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,-1.77635684e-15 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,-1.77635684e-15 L14.023298,-1.77635684e-15 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M18,22 C18.5522847,22 19,22.4477153 19,23 C19,23.5522847 18.5522847,24 18,24 L5,24 C4.44771525,24 4,23.5522847 4,23 C4,22.4477153 4.44771525,22 5,22 L18,22 Z M5.19617566,14.1472263 L5.28035748,14.2199306 L7,15.9396269 L8.71964252,14.2199306 C9.0128742,13.9266898 9.48684457,13.9266898 9.78007625,14.2199306 C10.0466505,14.4865132 10.0708845,14.9024713 9.85277831,15.196213 L9.78007625,15.2803975 L8.06043372,17.0000937 L9.78007625,18.71979 C10.0733079,19.0130308 10.0733079,19.487016 9.78007625,19.7802569 C9.63383539,19.9265023 9.44184738,20 9.24985938,20 C9.09626898,20 8.94267858,19.9529615 8.81251072,19.8592684 L8.71964252,19.7802569 L7,18.0605606 L5.28035748,19.7802569 C5.13411662,19.9265023 4.94212862,20 4.75014062,20 C4.55815262,20 4.36616461,19.9265023 4.21992375,19.7802569 C3.95334951,19.5136743 3.92911548,19.0977162 4.14722169,18.8039745 L4.21992375,18.71979 L5.93956628,17.0000937 L4.21992375,15.2803975 C3.92669208,14.9871567 3.92669208,14.5131715 4.21992375,14.2199306 C4.486498,13.953348 4.90244308,13.9291133 5.19617566,14.1472263 Z M16,-1.77635684e-15 L23,7 L16,7 L16,-1.77635684e-15 Z" })
  )
);
R.displayName = "FileTypeEsig23x28";
const v = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M23,27 C23.5522847,27 24,27.4477153 24,28 L24,29 C24,29.5522847 23.5522847,30 23,30 L7,30 C6.44771525,30 6,29.5522847 6,29 L6,28 C6,27.4477153 6.44771525,27 7,27 L23,27 Z M7.19617566,18.1472263 L7.28035748,18.2199306 L9,19.9396269 L10.7196425,18.2199306 C11.0128742,17.9266898 11.4868446,17.9266898 11.7800762,18.2199306 C12.0466505,18.4865132 12.0708845,18.9024713 11.8527783,19.196213 L11.7800762,19.2803975 L10.0604337,21.0000937 L11.7800762,22.71979 C12.0733079,23.0130308 12.0733079,23.487016 11.7800762,23.7802569 C11.6338354,23.9265023 11.4418474,24 11.2498594,24 C11.096269,24 10.9426786,23.9529615 10.8125107,23.8592684 L10.7196425,23.7802569 L9,22.0605606 L7.28035748,23.7802569 C7.13411662,23.9265023 6.94212862,24 6.75014062,24 C6.55815262,24 6.36616461,23.9265023 6.21992375,23.7802569 C5.95334951,23.5136743 5.92911548,23.0977162 6.14722169,22.8039745 L6.21992375,22.71979 L7.93956628,21.0000937 L6.21992375,19.2803975 C5.92669208,18.9871567 5.92669208,18.5131715 6.21992375,18.2199306 C6.486498,17.953348 6.90244308,17.9291133 7.19617566,18.1472263 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
v.displayName = "FileTypeEsig30x36";
const k = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M6,14 C6.55228475,14 7,14.4477153 7,15 C7,15.5522847 6.55228475,16 6,16 L5,16 C4.44771525,16 4,15.5522847 4,15 C4,14.4477153 4.44771525,14 5,14 L6,14 Z M11,14 C11.5522847,14 12,14.4477153 12,15 C12,15.5522847 11.5522847,16 11,16 L10,16 C9.44771525,16 9,15.5522847 9,15 C9,14.4477153 9.44771525,14 10,14 L11,14 Z M11,10 C11.5522847,10 12,10.4477153 12,11 C12,11.5522847 11.5522847,12 11,12 L5,12 C4.44771525,12 4,11.5522847 4,11 C4,10.4477153 4.44771525,10 5,10 L11,10 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
k.displayName = "FileTypeExcel16x20";
const w = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M8,18 C8.55228475,18 9,18.4477153 9,19 C9,19.5522847 8.55228475,20 8,20 L5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.4477153 4.44771525,18 5,18 L8,18 Z M15,18 C15.5522847,18 16,18.4477153 16,19 C16,19.5522847 15.5522847,20 15,20 L12,20 C11.4477153,20 11,19.5522847 11,19 C11,18.4477153 11.4477153,18 12,18 L15,18 Z M8,15 C8.55228475,15 9,15.4477153 9,16 C9,16.5522847 8.55228475,17 8,17 L5,17 C4.44771525,17 4,16.5522847 4,16 C4,15.4477153 4.44771525,15 5,15 L8,15 Z M15,15 C15.5522847,15 16,15.4477153 16,16 C16,16.5522847 15.5522847,17 15,17 L12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 L15,15 Z M15,12 C15.5522847,12 16,12.4477153 16,13 C16,13.5522847 15.5522847,14 15,14 L5,14 C4.44771525,14 4,13.5522847 4,13 C4,12.4477153 4.44771525,12 5,12 L15,12 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
w.displayName = "FileTypeExcel20x24";
const I = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M10,21 C10.5522847,21 11,21.4477153 11,22 C11,22.5522847 10.5522847,23 10,23 L6,23 C5.44771525,23 5,22.5522847 5,22 C5,21.4477153 5.44771525,21 6,21 L10,21 Z M17,21 C17.5522847,21 18,21.4477153 18,22 C18,22.5522847 17.5522847,23 17,23 L13,23 C12.4477153,23 12,22.5522847 12,22 C12,21.4477153 12.4477153,21 13,21 L17,21 Z M10,18 C10.5522847,18 11,18.4477153 11,19 C11,19.5522847 10.5522847,20 10,20 L6,20 C5.44771525,20 5,19.5522847 5,19 C5,18.4477153 5.44771525,18 6,18 L10,18 Z M17,18 C17.5522847,18 18,18.4477153 18,19 C18,19.5522847 17.5522847,20 17,20 L13,20 C12.4477153,20 12,19.5522847 12,19 C12,18.4477153 12.4477153,18 13,18 L17,18 Z M17,15 C17.5522847,15 18,15.4477153 18,16 C18,16.5522847 17.5522847,17 17,17 L6,17 C5.44771525,17 5,16.5522847 5,16 C5,15.4477153 5.44771525,15 6,15 L17,15 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
I.displayName = "FileTypeExcel23x28";
const F = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M13,27 C13.5522847,27 14,27.4477153 14,28 L14,29 C14,29.5522847 13.5522847,30 13,30 L7,30 C6.44771525,30 6,29.5522847 6,29 L6,28 C6,27.4477153 6.44771525,27 7,27 L13,27 Z M23,27 C23.5522847,27 24,27.4477153 24,28 L24,29 C24,29.5522847 23.5522847,30 23,30 L17,30 C16.4477153,30 16,29.5522847 16,29 L16,28 C16,27.4477153 16.4477153,27 17,27 L23,27 Z M13,23 C13.5522847,23 14,23.4477153 14,24 L14,25 C14,25.5522847 13.5522847,26 13,26 L7,26 C6.44771525,26 6,25.5522847 6,25 L6,24 C6,23.4477153 6.44771525,23 7,23 L13,23 Z M23,23 C23.5522847,23 24,23.4477153 24,24 L24,25 C24,25.5522847 23.5522847,26 23,26 L17,26 C16.4477153,26 16,25.5522847 16,25 L16,24 C16,23.4477153 16.4477153,23 17,23 L23,23 Z M23,19 C23.5522847,19 24,19.4477153 24,20 L24,21 C24,21.5522847 23.5522847,22 23,22 L7,22 C6.44771525,22 6,21.5522847 6,21 L6,20 C6,19.4477153 6.44771525,19 7,19 L23,19 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
F.displayName = "FileTypeExcel30x36";
const B = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M7,12 L11,17 L3,17 L7,12 Z M10.5,10 C11.328,10 12,10.672 12,11.5 C12,12.328 11.328,13 10.5,13 C9.672,13 9,12.328 9,11.5 C9,10.672 9.672,10 10.5,10 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
B.displayName = "FileTypeImage16x20";
const T = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M9,14 L14,20 L4,20 L9,14 Z M14,12 C15.104,12 16,12.896 16,14 C16,15.104 15.104,16 14,16 C12.896,16 12,15.104 12,14 C12,12.896 12.896,12 14,12 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
T.displayName = "FileTypeImage20x24";
const _ = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M10.25,16.5 L16.5,24 L4,24 L10.25,16.5 Z M16.5,14 C17.88,14 19,15.12 19,16.5 C19,17.88 17.88,19 16.5,19 C15.12,19 14,17.88 14,16.5 C14,15.12 15.12,14 16.5,14 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
_.displayName = "FileTypeImage23x28";
const N = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M13.5,21 L21,30 L6,30 L13.5,21 Z M21,18 C22.656,18 24,19.344 24,21 C24,22.656 22.656,24 21,24 C19.344,24 18,22.656 18,21 C18,19.344 19.344,18 21,18 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
N.displayName = "FileTypeImage30x36";
const j = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M6.38193522,11.91225 L6.91241035,12.44275 L6.08994891,13.26525 C5.63647017,13.71875 5.63647017,14.4565 6.08994891,14.91 C6.54367764,15.36375 7.28164305,15.3635 7.7348718,14.91 L7.7348718,14.91 L8.55683327,14.0875 L9.0873084,14.618 L8.26484696,15.4405 C7.89211443,15.8135 7.40188741,16 6.91216037,16 C6.42243332,16 5.93245629,15.8135 5.55947377,15.4405 C4.81350874,14.6945 4.81350874,13.48075 5.55947377,12.73475 L5.55947377,12.73475 L6.38193522,11.91225 Z M8.61008078,11.8595 C8.75657391,11.713 8.99406278,11.713 9.14055591,11.8595 C9.28704904,12.006 9.28704904,12.2435 9.14055591,12.39 L9.14055591,12.39 L7.39013796,14.1405 C7.31689139,14.21375 7.22089589,14.2505 7.12490039,14.2505 C7.02890489,14.2505 6.93290939,14.21375 6.85966283,14.1405 C6.71316969,13.994 6.71316969,13.7565 6.85966283,13.61 L6.85966283,13.61 Z M7.7348718,10.5595 C8.48083683,9.8135 9.69477993,9.8135 10.440495,10.5595 C11.18646,11.3055 11.18646,12.51925 10.440745,13.2655 L10.440745,13.2655 L9.61828351,14.088 L9.08780838,13.5575 L9.91026983,12.735 C10.3637486,12.2815 10.3637486,11.54375 9.91026983,11.09025 C9.68353046,10.8635 9.38554442,10.75 9.08780838,10.75 C8.78982235,10.75 8.49208631,10.86325 8.26534693,11.09 L8.26534693,11.09 L7.44288549,11.9125 L6.91241035,11.382 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
j.displayName = "FileTypeLink16x20";
const O = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M7.84258029,14.5496667 L8.54988047,15.257 L7.45326521,16.3536667 C6.84862689,16.9583333 6.84862689,17.942 7.45326521,18.5466667 C8.05823685,19.1516667 9.04219073,19.1513333 9.64649573,18.5466667 L9.64649573,18.5466667 L10.7424444,17.45 L11.4497445,18.1573333 L10.3531293,19.254 C9.85615257,19.7513333 9.20251655,20 8.54954715,20 C7.89657776,20 7.24327505,19.7513333 6.74596503,19.254 C5.75134499,18.2593333 5.75134499,16.641 6.74596503,15.6463333 L6.74596503,15.6463333 L7.84258029,14.5496667 Z M10.813441,14.4793333 C11.0087652,14.284 11.325417,14.284 11.5207412,14.4793333 C11.7160654,14.6746667 11.7160654,14.9913333 11.5207412,15.1866667 L11.5207412,15.1866667 L9.18685061,17.5206667 C9.08918853,17.6183333 8.96119453,17.6673333 8.83320053,17.6673333 C8.70520653,17.6673333 8.57721252,17.6183333 8.47955044,17.5206667 C8.28422626,17.3253333 8.28422626,17.0086667 8.47955044,16.8133333 L8.47955044,16.8133333 Z M9.64649573,12.746 C10.6411158,11.7513333 12.2597066,11.7513333 13.2539933,12.746 C14.2486133,13.7406667 14.2486133,15.359 13.2543266,16.354 L13.2543266,16.354 L12.1577114,17.4506667 L11.4504112,16.7433333 L12.5470264,15.6466667 C13.1516648,15.042 13.1516648,14.0583333 12.5470264,13.4536667 C12.2447073,13.1513333 11.8473926,13 11.4504112,13 C11.0530965,13 10.6561151,13.151 10.3537959,13.4533333 L10.3537959,13.4533333 L9.25718065,14.55 L8.54988047,13.8426667 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
O.displayName = "FileTypeLink20x24";
const $ = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M8.80333333,17.1870833 L9.6875,18.07125 L8.31666667,19.4420833 C7.56083333,20.1979167 7.56083333,21.4275 8.31666667,22.1833333 C9.07291667,22.9395833 10.3029167,22.9391667 11.0583333,22.1833333 L11.0583333,22.1833333 L12.4283333,20.8125 L13.3125,21.6966667 L11.9416667,23.0675 C11.3204167,23.6891667 10.5033333,24 9.68708333,24 C8.87083333,24 8.05416667,23.6891667 7.4325,23.0675 C6.18916667,21.8241667 6.18916667,19.80125 7.4325,18.5579167 L7.4325,18.5579167 L8.80333333,17.1870833 Z M12.5170833,17.0991667 C12.76125,16.855 13.1570833,16.855 13.40125,17.0991667 C13.6454167,17.3433333 13.6454167,17.7391667 13.40125,17.9833333 L13.40125,17.9833333 L10.48375,20.9008333 C10.3616667,21.0229167 10.2016667,21.0841667 10.0416667,21.0841667 C9.88166667,21.0841667 9.72166667,21.0229167 9.59958333,20.9008333 C9.35541667,20.6566667 9.35541667,20.2608333 9.59958333,20.0166667 L9.59958333,20.0166667 Z M11.0583333,14.9325 C12.3016667,13.6891667 14.325,13.6891667 15.5679167,14.9325 C16.81125,16.1758333 16.81125,18.19875 15.5683333,19.4425 L15.5683333,19.4425 L14.1975,20.8133333 L13.3133333,19.9291667 L14.6841667,18.5583333 C15.44,17.8025 15.44,16.5729167 14.6841667,15.8170833 C14.30625,15.4391667 13.8095833,15.25 13.3133333,15.25 C12.8166667,15.25 12.3204167,15.43875 11.9425,15.8166667 L11.9425,15.8166667 L10.5716667,17.1875 L9.6875,16.3033333 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
$.displayName = "FileTypeLink23x28";
const H = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M11.7638704,21.8245 L12.8248207,22.8855 L11.1798978,24.5305 C10.2729403,25.4375 10.2729403,26.913 11.1798978,27.82 C12.0873553,28.7275 13.5632861,28.727 14.4697436,27.82 L14.4697436,27.82 L16.1136665,26.175 L17.1746168,27.236 L15.5296939,28.881 C14.7842289,29.627 13.8037748,30 12.8243207,30 C11.8448666,30 10.8649126,29.627 10.1189475,28.881 C8.62701748,27.389 8.62701748,24.9615 10.1189475,23.4695 L10.1189475,23.4695 L11.7638704,21.8245 Z M16.2201616,21.719 C16.5131478,21.426 16.9881256,21.426 17.2811118,21.719 C17.5740981,22.012 17.5740981,22.487 17.2811118,22.78 L17.2811118,22.78 L13.7802759,26.281 C13.6337828,26.4275 13.4417918,26.501 13.2498008,26.501 C13.0578098,26.501 12.8658188,26.4275 12.7193257,26.281 C12.4263394,25.988 12.4263394,25.513 12.7193257,25.22 L12.7193257,25.22 Z M14.4697436,19.119 C15.9616737,17.627 18.3895599,17.627 19.8809899,19.119 C21.37292,20.611 21.37292,23.0385 19.8814899,24.531 L19.8814899,24.531 L18.236567,26.176 L17.1756168,25.115 L18.8205397,23.47 C19.7274971,22.563 19.7274971,21.0875 18.8205397,20.1805 C18.3670609,19.727 17.7710888,19.5 17.1756168,19.5 C16.5796447,19.5 15.9841726,19.7265 15.5306939,20.18 L15.5306939,20.18 L13.885771,21.825 L12.8248207,20.764 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
H.displayName = "FileTypeLink30x36";
const z = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M12,12.2967 L12,15.3 C12,15.68675 11.7016667,16 11.3333333,16 L11.3333333,16 L4.66666667,16 C4.29833333,16 4,15.68675 4,15.3 L4,15.3 L4,12.29705 L7.30166667,13.89725 C7.52333333,14.0047 7.76166667,14.05825 8,14.05825 C8.23833333,14.05825 8.47666667,14.0047 8.69833333,13.8969 L8.69833333,13.8969 L12,12.2967 Z M11.3333333,10 C11.7016667,10 12,10.31325 12,10.7 L12,10.7 L12,11.526 L8.41933333,13.2613 C8.153,13.39045 7.84733333,13.3901 7.581,13.2613 L7.581,13.2613 L4,11.526 L4,10.7 C4,10.31325 4.29833333,10 4.66666667,10 L4.66666667,10 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
z.displayName = "FileTypeMail16x20";
const G = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M16,14.281 L16,19 C16,19.5525 15.5525,20 15,20 L15,20 L5,20 C4.4475,20 4,19.5525 4,19 L4,19 L4,14.2815 L8.9525,16.5675 C9.285,16.721 9.6425,16.7975 10,16.7975 C10.3575,16.7975 10.715,16.721 11.0475,16.567 L11.0475,16.567 L16,14.281 Z M15,12 C15.5525,12 16,12.4475 16,13 L16,13 L16,13.18 L10.629,15.659 C10.2295,15.8435 9.771,15.843 9.3715,15.659 L9.3715,15.659 L4,13.18 L4,13 C4,12.4475 4.4475,12 5,12 L5,12 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
G.displayName = "FileTypeMail20x24";
const W = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M18,17.281 L18,22 C18,22.5525 17.5152083,23 16.9166667,23 L16.9166667,23 L6.08333333,23 C5.48479167,23 5,22.5525 5,22 L5,22 L5,17.2815 L10.3652083,19.5675 C10.7254167,19.721 11.1127083,19.7975 11.5,19.7975 C11.8872917,19.7975 12.2745833,19.721 12.6347917,19.567 L12.6347917,19.567 L18,17.281 Z M16.9166667,15 C17.5152083,15 18,15.4475 18,16 L18,16 L18,16.18 L12.1814167,18.659 C11.748625,18.8435 11.2519167,18.843 10.819125,18.659 L10.819125,18.659 L5,16.18 L5,16 C5,15.4475 5.48479167,15 6.08333333,15 L6.08333333,15 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
W.displayName = "FileTypeMail23x28";
const S = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M24,21.4215 L24,28.5 C24,29.32875 23.32875,30 22.5,30 L22.5,30 L7.5,30 C6.67125,30 6,29.32875 6,28.5 L6,28.5 L6,21.42225 L13.42875,24.85125 C13.9275,25.0815 14.46375,25.19625 15,25.19625 C15.53625,25.19625 16.0725,25.0815 16.57125,24.8505 L16.57125,24.8505 L24,21.4215 Z M22.5,18 C23.32875,18 24,18.67125 24,19.5 L24,19.5 L24,19.77 L15.9435,23.4885 C15.34425,23.76525 14.6565,23.7645 14.05725,23.4885 L14.05725,23.4885 L6,19.77 L6,19.5 C6,18.67125 6.67125,18 7.5,18 L7.5,18 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
S.displayName = "FileTypeMail30x36";
const A = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 16", width: "12", height: "16" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement(
      "g",
      null,
      L.createElement("path", { d: "M7,0 L7,5 L12,5 L12,14 C12,15.1045695 11.1045695,16 10,16 L2,16 C0.8954305,16 1.3527075e-16,15.1045695 0,14 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L7,0 Z M11,6 L1,6 L1,14 L11,14 L11,6 Z M6,7 L6,10 L9,10 C9,11.6568542 7.65685425,13 6,13 C4.34314575,13 3,11.6568542 3,10 C3,8.40231912 4.24891996,7.09633912 5.82372721,7.00509269 L6,7 Z M7.00083226,7.17100001 C7.85255296,7.47232421 8.52763154,8.14738804 8.82897577,8.99909928 L7,9 L7.00083226,7.17100001 Z M8,0 L12,4 L8,4 L8,0 Z" })
    )
  )
);
A.displayName = "FileTypePowerpoint12x16";
const P = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M8,10 L8,13 L11,13 C11,14.6568542 9.65685425,16 8,16 C6.34314575,16 5,14.6568542 5,13 C5,11.4023191 6.24891996,10.0963391 7.82372721,10.0050927 L8,10 Z M9,12 L8.99963831,9.99990693 C9.97782813,10.2515346 10.7479844,11.021496 10.9998903,11.9995741 L9,12 L8.99963831,9.99990693 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
P.displayName = "FileTypePowerpoint16x20";
const q = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M10,12 L10,16 L14,16 C14,18.209139 12.209139,20 10,20 C7.790861,20 6,18.209139 6,16 C6,13.8578046 7.68396847,12.1089211 9.80035966,12.0048953 L10,12 Z M11,15 L10.9999149,12.1259956 C12.4053088,12.4876858 13.5117973,13.5939648 13.8737865,14.9992387 L11,15 L10.9999149,12.1259956 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
q.displayName = "FileTypePowerpoint20x24";
const D = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M11.0077698,14.0275004 L11.0080946,19.0152025 L15.9906569,19.0155276 C15.7412838,21.2722251 13.8299591,23.0274316 11.5091064,23.0274316 C9.0187957,23.0274316 7,21.0065534 7,18.5136738 C7,16.1904271 8.7533978,14.2771308 11.0077698,14.0275004 Z M12.0000444,17.999122 L11.9993311,14.0000421 C13.930809,14.5460638 15.4527149,16.0678119 15.9989543,17.9991935 L12.0000444,17.999122 L11.9993311,14.0000421 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
D.displayName = "FileTypePowerpoint23x28";
const U = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M15,18 L15,24 L21,24 C21,27.3137085 18.3137085,30 15,30 C11.6862915,30 9,27.3137085 9,24 C9,20.7616031 11.5655749,18.1224282 14.7750617,18.0041385 L15,18 Z M16,23 L16.0004141,18.0001066 C18.4453145,18.6295418 20.3701565,20.5542615 20.9997662,22.9990919 L16,23 L16.0004141,18.0001066 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
U.displayName = "FileTypePowerpoint30x36";
const J = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M9,14 C9.55228475,14 10,14.4477153 10,15 C10,15.5522847 9.55228475,16 9,16 L5,16 C4.44771525,16 4,15.5522847 4,15 C4,14.4477153 4.44771525,14 5,14 L9,14 Z M11,11 C11.5522847,11 12,11.4477153 12,12 C12,12.5522847 11.5522847,13 11,13 L5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 L11,11 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
J.displayName = "FileTypeText16x20";
const V = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M11,18 C11.5522847,18 12,18.4477153 12,19 C12,19.5522847 11.5522847,20 11,20 L5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.4477153 4.44771525,18 5,18 L11,18 Z M15,15 C15.5522847,15 16,15.4477153 16,16 C16,16.5522847 15.5522847,17 15,17 L5,17 C4.44771525,17 4,16.5522847 4,16 C4,15.4477153 4.44771525,15 5,15 L15,15 Z M13,12 C13.5522847,12 14,12.4477153 14,13 C14,13.5522847 13.5522847,14 13,14 L5,14 C4.44771525,14 4,13.5522847 4,13 C4,12.4477153 4.44771525,12 5,12 L13,12 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
V.displayName = "FileTypeText20x24";
const Y = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M13,21 C13.5522847,21 14,21.4477153 14,22 C14,22.5522847 13.5522847,23 13,23 L6,23 C5.44771525,23 5,22.5522847 5,22 C5,21.4477153 5.44771525,21 6,21 L13,21 Z M17,18 C17.5522847,18 18,18.4477153 18,19 C18,19.5522847 17.5522847,20 17,20 L6,20 C5.44771525,20 5,19.5522847 5,19 C5,18.4477153 5.44771525,18 6,18 L17,18 Z M15,15 C15.5522847,15 16,15.4477153 16,16 C16,16.5522847 15.5522847,17 15,17 L6,17 C5.44771525,17 5,16.5522847 5,16 C5,15.4477153 5.44771525,15 6,15 L15,15 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
Y.displayName = "FileTypeText23x28";
const K = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M17,27 C17.5522847,27 18,27.4477153 18,28 L18,29 C18,29.5522847 17.5522847,30 17,30 L7,30 C6.44771525,30 6,29.5522847 6,29 L6,28 C6,27.4477153 6.44771525,27 7,27 L17,27 Z M23,23 C23.5522847,23 24,23.4477153 24,24 L24,25 C24,25.5522847 23.5522847,26 23,26 L7,26 C6.44771525,26 6,25.5522847 6,25 L6,24 C6,23.4477153 6.44771525,23 7,23 L23,23 Z M20,19 C20.5522847,19 21,19.4477153 21,20 L21,21 C21,21.5522847 20.5522847,22 20,22 L7,22 C6.44771525,22 6,21.5522847 6,21 L6,20 C6,19.4477153 6.44771525,19 7,19 L20,19 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
K.displayName = "FileTypeText30x36";
const Q = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L10,0 Z M14,8 L2,8 L2,18 L14,18 L14,8 Z M11,10 C11.5522847,10 12,10.4477153 12,11 L12,15 C12,15.5522847 11.5522847,16 11,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L4,11 C4,10.4477153 4.44771525,10 5,10 L11,10 Z M12,0 L16,4 L12,4 L12,0 Z" })
  )
);
Q.displayName = "FileTypeUnknown16x20";
const X = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M12,0 L12,8 L20,8 L20,22 C20,23.0538182 19.1836033,23.9181157 18.1491916,23.9945109 L18,24 L2,24 C0.946181818,24 0.0818842975,23.1836033 0.00548910594,22.1491916 L0,22 L0,2 C0,0.946181818 0.816396694,0.0818842975 1.85080841,0.00548910594 L2,0 L12,0 Z M18,10 L2,10 L2,22 L18,22 L18,10 Z M14,12 C15.1045695,12 16,12.8954305 16,14 L16,18 C16,19.1045695 15.1045695,20 14,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,14 C4,12.8954305 4.8954305,12 6,12 L14,12 Z M14,0 L20,6 L14,6 L14,0 Z" })
  )
);
X.displayName = "FileTypeUnknown20x24";
const e1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14.023298,0 L14.023298,9.00809152 L23,9.00809152 L23,25.6666667 C23,26.901 22.0125333,27.9124676 20.7642403,27.9946136 L20.6,28 L2.4,28 C1.1304,28 0.0900333333,27.039963 0.00554027778,25.8263447 L0,25.6666667 L0,2.33333333 C0,1.099 0.987466667,0.0875324074 2.23575972,0.00538638117 L2.4,0 L14.023298,0 Z M21,12 L2,12 L2,26 L21,26 L21,12 Z M17,15 C17.5522847,15 18,15.4477153 18,16 L18,22 C18,22.5522847 17.5522847,23 17,23 L6,23 C5.44771525,23 5,22.5522847 5,22 L5,16 C5,15.4477153 5.44771525,15 6,15 L17,15 Z M16,0 L23,7 L16,7 L16,0 Z" })
  )
);
e1.displayName = "FileTypeUnknown23x28";
const L1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M18,0 L18,12 L30,12 L30,33 C30,34.5968571 28.7502857,35.903602 27.1761877,35.9949042 L27,36 L3,36 C1.40314286,36 0.0963979592,34.7502857 0.00509584548,33.1761877 L0,33 L0,3 C0,1.40314286 1.24971429,0.0963979592 2.82381232,0.00509584548 L3,0 L18,0 Z M27,15 L3,15 L3,33 L27,33 L27,15 Z M22,18 C23.1045695,18 24,18.8954305 24,20 L24,28 C24,29.1045695 23.1045695,30 22,30 L8,30 C6.8954305,30 6,29.1045695 6,28 L6,20 C6,18.8954305 6.8954305,18 8,18 L22,18 Z M21,0 L30,9 L21,9 L21,0 Z" })
  )
);
L1.displayName = "FileTypeUnknown30x36";
const t1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { d: "M4,2 L6,2 C6.552,2 7,1.552 7,1 C7,0.448 6.552,0 6,0 L6,0 L12,0 L16,4 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L4,0 L4,2 Z M6,8 L4,8 L4,13 C4,14.657 5.343,16 7,16 C8.657,16 10,14.657 10,13 L10,13 L10,10 L6,10 C6.552,10 7,9.552 7,9 C7,8.448 6.552,8 6,8 L6,8 Z M7,12 C7.552,12 8,12.448 8,13 C8,13.552 7.552,14 7,14 C6.448,14 6,13.552 6,13 C6,12.448 6.448,12 7,12 Z M10,6 L8,6 C7.448,6 7,6.448 7,7 C7,7.552 7.448,8 8,8 L8,8 L10,8 L10,6 Z M6,4 L4,4 L4,6 L6,6 C6.552,6 7,5.552 7,5 C7,4.448 6.552,4 6,4 L6,4 Z M10,2 L8,2 C7.448,2 7,2.448 7,3 C7,3.552 7.448,4 8,4 L8,4 L10,4 L10,2 Z" })
  )
);
t1.displayName = "FileTypeZip16x20";
const i1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 24", width: "20", height: "24" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M14,0 L12,0 L12,2 L10,2 C9.448,2 9,1.552 9,1 C9,0.448 9.448,0 10,0 L2,0 C0.896,0 0,0.896 0,2 L0,22 C0,23.104 0.896,24 2,24 L18,24 C19.104,24 20,23.104 20,22 L20,6 L14,0 Z M6,2 L8,2 C8.552,2 9,2.448 9,3 C9,3.552 8.552,4 8,4 L6,4 L6,2 Z M6,6 L8,6 C8.552,6 9,6.448 9,7 C9,7.552 8.552,8 8,8 L6,8 L6,6 Z M12,15 C12,16.657 10.657,18 9,18 C7.343,18 6,16.657 6,15 L6,10 L8,10 C8.552,10 9,10.448 9,11 C9,11.552 8.552,12 8,12 L12,12 L12,15 Z M12,10 L10,10 C9.448,10 9,9.552 9,9 C9,8.448 9.448,8 10,8 L12,8 L12,10 Z M12,6 L10,6 C9.448,6 9,5.552 9,5 C9,4.448 9.448,4 10,4 L12,4 L12,6 Z M9,16 C9.552,16 10,15.552 10,15 C10,14.448 9.552,14 9,14 C8.448,14 8,14.448 8,15 C8,15.552 8.448,16 9,16 Z" })
  )
);
i1.displayName = "FileTypeZip20x24";
const n1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 28", width: "23", height: "28" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M16.1,0 L13.8,0 L13.8,2.33333333 L11.5,2.33333333 C10.8652,2.33333333 10.35,1.81066667 10.35,1.16666667 C10.35,0.522666667 10.8652,0 11.5,0 L2.3,0 C1.0304,0 0,1.04533333 0,2.33333333 L0,25.6666667 C0,26.9546667 1.0304,28 2.3,28 L20.7,28 C21.9696,28 23,26.9546667 23,25.6666667 L23,7 L16.1,0 Z M6.9,2.33333333 L9.2,2.33333333 C9.8348,2.33333333 10.35,2.856 10.35,3.5 C10.35,4.144 9.8348,4.66666667 9.2,4.66666667 L6.9,4.66666667 L6.9,2.33333333 Z M6.9,7 L9.2,7 C9.8348,7 10.35,7.52266667 10.35,8.16666667 C10.35,8.81066667 9.8348,9.33333333 9.2,9.33333333 L6.9,9.33333333 L6.9,7 Z M13.8,17.5 C13.8,19.4331667 12.25555,21 10.35,21 C8.44445,21 6.9,19.4331667 6.9,17.5 L6.9,11.6666667 L9.2,11.6666667 C9.8348,11.6666667 10.35,12.1893333 10.35,12.8333333 C10.35,13.4773333 9.8348,14 9.2,14 L13.8,14 L13.8,17.5 Z M13.8,11.6666667 L11.5,11.6666667 C10.8652,11.6666667 10.35,11.144 10.35,10.5 C10.35,9.856 10.8652,9.33333333 11.5,9.33333333 L13.8,9.33333333 L13.8,11.6666667 Z M13.8,7 L11.5,7 C10.8652,7 10.35,6.47733333 10.35,5.83333333 C10.35,5.18933333 10.8652,4.66666667 11.5,4.66666667 L13.8,4.66666667 L13.8,7 Z M10.35,18.6666667 C10.9848,18.6666667 11.5,18.144 11.5,17.5 C11.5,16.856 10.9848,16.3333333 10.35,16.3333333 C9.7152,16.3333333 9.2,16.856 9.2,17.5 C9.2,18.144 9.7152,18.6666667 10.35,18.6666667 Z" })
  )
);
n1.displayName = "FileTypeZip23x28";
const r1 = (e) => L.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 30 36", width: "30", height: "36" }, e),
  L.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    L.createElement("path", { fillRule: "nonzero", d: "M21,0 L18,0 L18,3 L15,3 C14.172,3 13.5,2.328 13.5,1.5 C13.5,0.672 14.172,0 15,0 L3,0 C1.344,0 0,1.344 0,3 L0,33 C0,34.656 1.344,36 3,36 L27,36 C28.656,36 30,34.656 30,33 L30,9 L21,0 Z M9,3 L12,3 C12.828,3 13.5,3.672 13.5,4.5 C13.5,5.328 12.828,6 12,6 L9,6 L9,3 Z M9,9 L12,9 C12.828,9 13.5,9.672 13.5,10.5 C13.5,11.328 12.828,12 12,12 L9,12 L9,9 Z M18,22.5 C18,24.9855 15.9855,27 13.5,27 C11.0145,27 9,24.9855 9,22.5 L9,15 L12,15 C12.828,15 13.5,15.672 13.5,16.5 C13.5,17.328 12.828,18 12,18 L18,18 L18,22.5 Z M18,15 L15,15 C14.172,15 13.5,14.328 13.5,13.5 C13.5,12.672 14.172,12 15,12 L18,12 L18,15 Z M18,9 L15,9 C14.172,9 13.5,8.328 13.5,7.5 C13.5,6.672 14.172,6 15,6 L18,6 L18,9 Z M13.5,24 C14.328,24 15,23.328 15,22.5 C15,21.672 14.328,21 13.5,21 C12.672,21 12,21.672 12,22.5 C12,23.328 12.672,24 13.5,24 Z" })
  )
);
r1.displayName = "FileTypeZip30x36";
var C = {};
(function(e) {
  var t = s1, i = c1;
  t(e, "__esModule", {
    value: !0
  }), e.getExtFromFileName = r, e.getFileTypeFromExt = d;
  var n = i(x());
  function r(a) {
    return (0, n.default)(a) ? a.toLowerCase().split(".").pop() : "";
  }
  function d(a) {
    switch ((0, n.default)(a) || (a = ""), r(a)) {
      case "pdf":
        return "pdf";
      case "docx":
      case "doc":
      case "docm":
      case "pages":
      case "odt":
        return "doc";
      case "xls":
      case "xlsx":
      case "csv":
      case "xlsm":
      case "ods":
        return "xls";
      case "ppt":
      case "key":
      case "kth":
        return "ppt";
      case "txt":
      case "rtf":
        return "txt";
      case "msg":
      case "eml":
        return "email";
      case "htm":
      case "html":
      case "url":
      case "mht":
      case "webarchive":
        return "webpage";
      case "zip":
      case "rar":
        return "archive";
      case "jpg":
      case "jpeg":
      case "tif":
      case "gif":
      case "png":
      case "ai":
      case "eps":
      case "tiff":
      case "psd":
      case "bmp":
        return "img";
      default:
        return "default";
    }
  }
})(C);
const E1 = {
  "fab-file-type-esig-16x20": b,
  "fab-file-type-esig-20x24": y,
  "fab-file-type-esig-23x28": R,
  "fab-file-type-esig-30x36": v,
  "fab-file-type-excel-16x20": k,
  "fab-file-type-excel-20x24": w,
  "fab-file-type-excel-23x28": I,
  "fab-file-type-excel-30x36": F,
  "fab-file-type-image-16x20": B,
  "fab-file-type-image-20x24": T,
  "fab-file-type-image-23x28": _,
  "fab-file-type-image-30x36": N,
  "fab-file-type-link-16x20": j,
  "fab-file-type-link-20x24": O,
  "fab-file-type-link-23x28": $,
  "fab-file-type-link-30x36": H,
  "fab-file-type-mail-16x20": z,
  "fab-file-type-mail-20x24": G,
  "fab-file-type-mail-23x28": W,
  "fab-file-type-mail-30x36": S,
  "fab-file-type-powerpoint-12x16": A,
  "fab-file-type-powerpoint-16x20": P,
  "fab-file-type-powerpoint-20x24": q,
  "fab-file-type-powerpoint-23x28": D,
  "fab-file-type-powerpoint-30x36": U,
  "fab-file-type-text-16x20": J,
  "fab-file-type-text-20x24": V,
  "fab-file-type-text-23x28": Y,
  "fab-file-type-text-30x36": K,
  "fab-file-type-unknown-16x20": Q,
  "fab-file-type-unknown-20x24": X,
  "fab-file-type-unknown-23x28": e1,
  "fab-file-type-unknown-30x36": L1,
  "fab-file-type-zip-16x20": t1,
  "fab-file-type-zip-20x24": i1,
  "fab-file-type-zip-23x28": n1,
  "fab-file-type-zip-30x36": r1
};
var b1 = x();
const y1 = /* @__PURE__ */ g(b1), R1 = "teenie", v1 = "16x20", k1 = "20x24", w1 = "23x28", I1 = "30x36", u = {
  teenie: v1,
  small: k1,
  medium: w1,
  large: I1
}, F1 = {
  teenie: 20,
  small: 24,
  medium: 28,
  large: 36
}, Z = {
  archive: "file-zipper-regular",
  default: "file-regular",
  doc: "file-lines-regular",
  excel: "file-spreadsheet-regular",
  email: "file-lines-regular",
  esig: "file-contract-regular",
  image: "file-image-regular",
  img: "file-image-regular",
  link: "file-regular",
  mail: "file-lines-regular",
  pdf: "file-lines-regular",
  powerpoint: "file-chart-pie-regular",
  ppt: "file-chart-pie-regular",
  text: "file-lines-regular",
  txt: "file-lines-regular",
  webpage: "file-lines-regular",
  xls: "file-spreadsheet-regular",
  zip: "file-zipper-regular"
};
var B1 = p1();
const T1 = /* @__PURE__ */ g(B1);
var _1 = f1();
const N1 = /* @__PURE__ */ g(_1), c = g1.createLogger("@fabric/file-icon | <FileIcon />");
function j1(e) {
  let t;
  switch (e) {
    case "doc":
      t = "doc";
      break;
    case "esig":
      t = "esig";
      break;
    case "xls":
      t = "excel";
      break;
    case "img":
      t = "image";
      break;
    case "webpage":
      t = "link";
      break;
    case "email":
      t = "mail";
      break;
    case "pdf":
      t = "pdf";
      break;
    case "ppt":
      t = "powerpoint";
      break;
    case "txt":
      t = "text";
      break;
    case "archive":
      t = "zip";
      break;
    default:
      t = "unknown", c.warn(`fileType of "${e}" invalid, defaulting to "unknown"`);
      break;
  }
  return t;
}
function O1(e) {
  return `fab-file-type-${z1(e)}`;
}
function $1(e, t) {
  const i = O1(e), n = H1(t);
  return `${i}-${n}`;
}
function H1(e) {
  const t = Object.keys(u);
  return (!y1(e) || t.indexOf(e) === -1) && (e = R1), u[e];
}
function z1(e) {
  let t;
  switch (e) {
    case "doc":
    case "pdf":
    case "text":
    case "txt":
      t = "text";
      break;
    case "excel":
    case "xls":
      t = "excel";
      break;
    case "powerpoint":
    case "ppt":
      t = "powerpoint";
      break;
    case "email":
    case "mail":
      t = "mail";
      break;
    case "webpage":
    case "link":
      t = "link";
      break;
    case "archive":
    case "zip":
      t = "zip";
      break;
    case "image":
    case "img":
      t = "image";
      break;
    case "esig":
      t = "esig";
      break;
    default:
      t = "unknown", c.warn(`fileType of "${e}" invalid, defaulting to "unknown"`);
      break;
  }
  return t;
}
function o(e) {
  return T1(e) || N1(e);
}
function G1(e) {
  return e === "esig" ? !1 : C.getFileTypeFromExt(e) === "default";
}
const W1 = [
  "archive",
  "email",
  "excel",
  "image",
  "img",
  "link",
  "mail",
  "powerpoint",
  "text",
  "webpage"
];
function S1({ esig: e, filename: t, type: i }) {
  if (e || i === "esig")
    return "esig";
  if (i === "default")
    return "default";
  if (i && W1.includes(i))
    return i;
  if (i) {
    const n = C.getFileTypeFromExt(i);
    if (n !== "default")
      return n;
  }
  return t ? C.getFileTypeFromExt(t) : "default";
}
function A1(e, t) {
  switch (e) {
    case "doc":
      return "#2076BB";
    case "xls":
    case "excel":
      return "#3AA837";
    case "pdf":
      return "#C32A2F";
    case "powerpoint":
    case "ppt":
      return "#C26C1A";
    case "esig":
      return "#87328F";
    default:
      return t.gray[600];
  }
}
const P1 = E()((e, { size: t }) => ({
  root: {
    flexShrink: 0,
    height: t,
    width: t
  }
})), q1 = E()(({ palette: e, mode: t }, { customFill: i }) => ({
  root: {
    outline: t === h1.Dye ? `2px solid ${u1.main}` : void 0,
    alignItems: "center",
    display: "inline-flex",
    justifyContent: "center",
    lineHeight: 0
  },
  customFill: {
    fill: i
  },
  doc: {
    fill: "#2076bb"
  },
  esig: {
    fill: "#87328f"
  },
  excel: {
    fill: "#42a149"
  },
  image: {
    fill: e.gray[700]
  },
  link: {
    fill: e.gray[700]
  },
  mail: {
    fill: e.gray[700]
  },
  pdf: {
    fill: "#c32a2f"
  },
  powerpoint: {
    fill: "#c26c1a"
  },
  text: {
    fill: e.gray[700]
  },
  unknown: {
    fill: e.gray[700]
  },
  zip: {
    fill: e.gray[700]
  }
})), a2 = ({
  // @startCleanup jade
  customFill: e = "",
  // @endCleanup jade
  esig: t = !1,
  filename: i = "",
  size: n = "teenie",
  type: r
}) => {
  const { classes: d, cx: a } = P1({ size: F1[n] }), { palette: a1 } = M1(), p = S1({ esig: t, filename: i, type: r }), { classes: m } = q1({ customFill: e });
  if (!t && o(r) && o(i))
    return c.error('"filename" or "type" is required.'), null;
  if (o(r) && o(i) && !d1.isBoolean(t))
    return c.error('"esig", "filename" or "type" is required.'), null;
  let l = i;
  t && (l = "esig"), !o(r) && !G1(r) && (l = r), t || (l = C.getFileTypeFromExt(l));
  const f = !o(e), M = $1(l, n), l1 = j1(l), h = E1[M], o1 = a(m.root, {
    [m[l1]]: !f,
    [m.customFill]: f
  });
  return Z1.ifFeature(
    "encore",
    /* @__PURE__ */ s.jsx(
      x1,
      {
        className: d.root,
        "data-fabric-component": "FileIcon",
        fill: A1(p, a1),
        name: Z[p] || Z.default
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: o1, "data-fabric-component": "FileIcon", children: h ? /* @__PURE__ */ s.jsx(h, { "aria-hidden": "true" }) : /* @__PURE__ */ s.jsx(m1, { "aria-hidden": "true", name: M }) })
  );
};
export {
  a2 as F,
  C as f
};
//# sourceMappingURL=file-icon-DTzfQjIh.mjs.map
